import styled from "styled-components";


export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content:  center;
    align-items: center;
`;

export const BigText = styled.h1`
    font-size: 7rem;
    margin: 0;
`;

export const Text = styled.p`
    font-size: 1.5rem;
`;